const API_BASE_URL = process.env.REACT_APP_API_URL || "https://aioapi.facebookindia.in/api";

const CART_API_URL = process.env.REACT_APP_CART_API_URL || "https://aioapi.facebookindia.in/api";

const PINCODE_API_URL = process.env.REACT_APP_PINCODE_API_URL || "https://aioapi.facebookindia.in/api";

export { API_BASE_URL, CART_API_URL, PINCODE_API_URL };
